import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { DialogContentText } from '@material-ui/core';
import theme from 'themes';
import themeDialog from 'themes-dialog';

import { InpostGeowidgetReact } from 'inpost-geowidget-react'
const token = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzQlpXVzFNZzVlQnpDYU1XU3JvTlBjRWFveFpXcW9Ua2FuZVB3X291LWxvIn0.eyJleHAiOjIwMzIzNDgxNzAsImlhdCI6MTcxNjk4ODE3MCwianRpIjoiN2IzY2IyMDgtNzMyOS00YTczLWE5OTQtYzU0ZTg0ZDEyODc5IiwiaXNzIjoiaHR0cHM6Ly9sb2dpbi5pbnBvc3QucGwvYXV0aC9yZWFsbXMvZXh0ZXJuYWwiLCJzdWIiOiJmOjEyNDc1MDUxLTFjMDMtNGU1OS1iYTBjLTJiNDU2OTVlZjUzNTpJb0NiTGF6RjB0UWdQcmJVeUV5YnJzVk5hN05PNXRwZ1RsemFTRHNBM1RFIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic2hpcHgiLCJzZXNzaW9uX3N0YXRlIjoiYmEwMjYxYmEtN2YyYi00Njc1LWI0YjctOTc4MjdhYmIxNmRhIiwic2NvcGUiOiJvcGVuaWQgYXBpOmFwaXBvaW50cyIsInNpZCI6ImJhMDI2MWJhLTdmMmItNDY3NS1iNGI3LTk3ODI3YWJiMTZkYSIsImFsbG93ZWRfcmVmZXJyZXJzIjoiIiwidXVpZCI6IjM1N2UyOTE5LWUzN2MtNDNlMS05MGVjLWZkYjRjNTJiZjQ5YyJ9.VGSn9WKdzbzp8TUPSUVHIBw8hlLYt03laRyfUI5VnlqIDJrkN3xfMDwoZn_blfcf5DP_OeiFkGPrNsFmm5k12ckXQDx6WXQr-f44Mx18bsnftxD3hgwfrrYbkGyn09NxQbzw7KWDgbIGiPsXZxf-VNrRGunDq4YM8cYlMoTd82Oi6b2Jl8De1M-j487f0IUibb7EF72eLAfaf701Ja9uWRGMS8SvNtjDxS0laKlRLcsyx2bhHa1f9QBrzJT33YpTnIOz9HGIpAZfJY8tG7fv8NdX1OCneL2LOd-3NNgoRWEgOHwGSjZ-xpzmELcJfwaAWjbDapoc-hXPQmh0lupsNw';



interface ModalProps {
    open: boolean,
    okCallback: (p: any) => void,
    cancelCallback?: () => void,
}



class Notifier extends React.Component<ModalProps & WithStyles<typeof styles> & WithTranslation> {
    //mapRef: any;

    constructor(props: ModalProps & WithStyles<typeof styles> & WithTranslation) {
        super(props, {});
        //this.mapRef = React.createRef() //as React.RefObject<L.Map>
    }

    Icon = (Icon: any, color: string = '#458B00') => {
        return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
    }

    apiReady = (api: any) => {
        //this.mapRef.current = api
       
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            //api.setView([position.coords.latitude, position.coords.longitude],)
            api.changePosition({longitude: position.coords.longitude, latitude: position.coords.latitude }, 15);
            //doSomething(position.coords.latitude, position.coords.longitude);
          });
        }
        // You can also use API Methods, as example
        //api.changePosition({longitude: 20.318968, latitude: 49.731131 }, 16);
        // console.log(api);
      }

    render() {
        const { classes } = this.props;
        

        return (
            <Dialog
                maxWidth="lg"
                open={this.props.open}
                onClose={this.props.cancelCallback}
                fullWidth
            >
                <DialogTitle disableTypography style={{paddingBottom: "0px"}}>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b><Trans>wybierz Paczkomat</Trans></b>
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>


                    <div style={{ height: "550px" }}>
                        <InpostGeowidgetReact token={token} identifier="geowidget" language='pl' config='parcelCollect' sandbox apiReady={this.apiReady} pointSelect={this.props.okCallback} />
                    </div>




                </DialogContent>
                <DialogActions>
                    {this.props.cancelCallback ?
                    <Button variant="outlined" color="primary" size="small" className={classes.actionButtons}
                        onClick={this.props.cancelCallback}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button> : null}
                    {/* <Button variant="contained" color="primary" size="small" className={classes.actionButtons}
                        onClick={this.props.okCallback}
                    >
                        <b>{this.props.okText}</b>
                    </Button> */}
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
    actionButtons: {
        textTransform: "none" as "none",
        fontSize: '0.8rem'
      },
      padding: {
        //whiteSpace: "pre" as "pre",
        paddingLeft: "7px",

        "@media (max-width: 600px)": {
            fontSize: "0.95rem",
        },
    },
    gutterBottom: {
        marginBottom: '0.5em',
        display: "flow-root" as "flow-root"
    },
});

export default withTranslation()(withStyles(styles)(Notifier));